var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-row",
        { staticClass: "mb-2" },
        [
          _c(
            "b-col",
            {
              staticClass: "text-md-left text-center text--white",
              attrs: { cols: "12", md: "6", lg: "4", xl: "3" },
            },
            [_c("span", { staticClass: "h4" }, [_vm._v("Employees")])]
          ),
          _c(
            "b-col",
            {
              staticClass: "text-right",
              attrs: {
                cols: "12",
                md: "6",
                lg: "4",
                "offset-lg": "4",
                xl: "3",
                "offset-xl": "6",
              },
            },
            [
              _c("AddEditEmployee", {
                on: {
                  refresh: function ($event) {
                    return _vm.init()
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "b-overlay",
        { attrs: { show: _vm.loading } },
        [
          _c(
            "b-card",
            {
              staticClass: "card-border text--black q-table-container",
              staticStyle: { "overflow-x": "auto" },
            },
            [
              _c(
                "div",
                { staticClass: "float-left mb-2" },
                [
                  _vm._v(" Search "),
                  _c("b-form-input", {
                    staticClass: "d-inline w-auto",
                    attrs: { debounce: "500" },
                    model: {
                      value: _vm.text,
                      callback: function ($$v) {
                        _vm.text = $$v
                      },
                      expression: "text",
                    },
                  }),
                ],
                1
              ),
              _vm.totalItems > _vm.filters.max
                ? _c("b-pagination", {
                    staticClass: "float-right",
                    attrs: {
                      "total-rows": _vm.totalItems,
                      "per-page": _vm.filters.max,
                      "aria-controls": "documentsTable",
                    },
                    on: { change: _vm.changePage },
                    model: {
                      value: _vm.filters.page,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "page", $$v)
                      },
                      expression: "filters.page",
                    },
                  })
                : _vm._e(),
              _c("b-table", {
                staticStyle: { "min-width": "1080px" },
                attrs: {
                  items: _vm.employees,
                  "no-local-sorting": "",
                  fields: _vm.fields,
                  "sort-by": _vm.sortBy,
                  "sort-desc": _vm.desc,
                  striped: "",
                },
                on: {
                  "sort-changed": _vm.sortingChanged,
                  "update:sortBy": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sort-by": function ($event) {
                    _vm.sortBy = $event
                  },
                  "update:sortDesc": function ($event) {
                    _vm.desc = $event
                  },
                  "update:sort-desc": function ($event) {
                    _vm.desc = $event
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "cell(lastname)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(data.item.firstname) +
                            " " +
                            _vm._s(data.item.lastname) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(lastlogin)",
                    fn: function (data) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              data.item.lastlogin
                                ? data.item.lastlogin
                                : "Never"
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "cell(actions)",
                    fn: function (data) {
                      return [
                        _c(
                          "div",
                          { staticClass: "text-right" },
                          [
                            _c(
                              "AddEditEmployee",
                              {
                                attrs: { id: +data.item.id },
                                on: {
                                  refresh: function ($event) {
                                    return _vm.init()
                                  },
                                },
                              },
                              [
                                [
                                  _c(
                                    "b-button",
                                    { attrs: { variant: "success" } },
                                    [
                                      _c("b-icon", {
                                        attrs: { icon: "pencil-square" },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                              ],
                              2
                            ),
                            _c(
                              "div",
                              { staticClass: "d-inline ml-2" },
                              [
                                data.item.active == 1
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "danger" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.disable(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "x-circle" },
                                        }),
                                      ],
                                      1
                                    )
                                  : _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "info" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.enable(data.item)
                                          },
                                        },
                                      },
                                      [
                                        _c("b-icon", {
                                          attrs: { icon: "arrow-clockwise" },
                                        }),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "d-inline ml-2" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: { variant: "success" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetPassword(data.item)
                                      },
                                    },
                                  },
                                  [
                                    _c("b-icon", {
                                      attrs: { icon: "key-fill" },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm.totalItems > _vm.filters.max
                ? _c("b-pagination", {
                    staticClass: "float-right",
                    attrs: {
                      "total-rows": _vm.totalItems,
                      "per-page": _vm.filters.max,
                      "aria-controls": "documentsTable",
                    },
                    on: { change: _vm.changePage },
                    model: {
                      value: _vm.filters.page,
                      callback: function ($$v) {
                        _vm.$set(_vm.filters, "page", $$v)
                      },
                      expression: "filters.page",
                    },
                  })
                : _vm._e(),
              _vm.totalItems > 10
                ? _c("div", { staticClass: "pl-1 text-left" }, [
                    _vm._v(" Per page: "),
                    _c(
                      "span",
                      {
                        staticClass: "ml-2 link",
                        class: _vm.filters.max == 10 ? "active" : "",
                        on: {
                          click: function ($event) {
                            _vm.filters.max = 10
                          },
                        },
                      },
                      [_vm._v("10")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "ml-2 link",
                        class: _vm.filters.max == 25 ? "active" : "",
                        attrs: { href: "javasript:void(0)" },
                        on: {
                          click: function ($event) {
                            _vm.filters.max = 25
                          },
                        },
                      },
                      [_vm._v("25")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "ml-2 link",
                        class: _vm.filters.max == 50 ? "active" : "",
                        attrs: { href: "javasript:void(0)" },
                        on: {
                          click: function ($event) {
                            _vm.filters.max = 50
                          },
                        },
                      },
                      [_vm._v("50")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "ml-2 link",
                        class: _vm.filters.max == 100 ? "active" : "",
                        attrs: { href: "javasript:void(0)" },
                        on: {
                          click: function ($event) {
                            _vm.filters.max = 100
                          },
                        },
                      },
                      [_vm._v("100")]
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }